import QRCode from "react-qr-code"
import phonepe_svg from '../media/phonepe.svg'
import gpay_svg from '../media/GPay.svg'
import bhim_svg from '../media/BHIM.svg'
import paytm_svg from '../media/paytm.svg'
import valueLinkLogo from '../media/pakistan_payments/value_link_global.png'
import jazzcashQR from "../media/pakistan_payments/jazzcash_qr.png"
import easypaisa from "../media/pakistan_payments/easypaisa_qr.png"
import './DepositMain.css'
import CopyToClipboard from "react-copy-to-clipboard"
import { useEffect, useState } from "react"



const PakistanPaymentPage = ({ paymentImg,
    orderDetails,
    pendingConfirmation,
    config,
    ispaid,
    qrRef,
    redirectLinks,
    showUTRNumber,
    redirectToPaymentApp,
    openWithSelectedApps,
    setOrderDetails,
    cancelButton,
    getBase64,
    fileValue,
    setFileValue,
    copyToClipboard,
    image,
    removeImg,
    togglePreview,
    errMsg,
    selectedMethod,
    setSelectedMethod
}) => {

    const [showCopiedInfo, setShowCopiedInfo] = useState(false)
    const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth && window.innerWidth <= 480)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerHeight > window.innerWidth && window.innerWidth <= 480) {
                setIsPortrait(true)
            } else {
                setIsPortrait(false)
            }
        }
        window.addEventListener("resize", handleResize)
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    const handleCopiedMessage = () => {
        setShowCopiedInfo(true)
        setTimeout(() => {
            setShowCopiedInfo(false)
        }, 2000)
    }

    return <div className="content">
        {isPortrait && <>
            <button id="ConfirmPayment1" disabled={!orderDetails?.utr || !fileValue} onClick={() => { pendingConfirmation() }}>Confirm Payment <i className="bi bi-check-circle-fill" style={{ color: "#fff" }}></i></button>
            <div className="qr-code-container1 mt-2">
                <div className="payment-proof">
                    <h6>{Boolean(fileValue) ? "Please check uploaded image before confirming payment." : "Please upload receipt after payment."}</h6>
                    <h6 style={{ fontSize: "14px", fontWeight: "700" }} className="text-center ms-auto me-auto text-danger">{errMsg}</h6>
                    {!fileValue && <div className=" d-flex justify-content-left mt-2" style={{ width: "90%" }} id="paymentProofDiv">
                        <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => { getBase64(e); setFileValue(e.target.value?.split("\\").pop()) }} name="paymentProof" id="paymentProof" />
                        <div id="fileName" onClick={() => document.getElementById("paymentProof").click()}>
                            <button className="green_btn chooseFile_btn">Choose File</button>
                            <span style={{ color: "#777" }}>{fileValue ? fileValue : 'Upload Payment Proof'}</span>
                        </div>
                    </div>}
                    {
                        fileValue && <div className="image_preview">
                            {/* <button title="Remove" className="remove_img fa-solid fa-xmark" onClick={removeImg}></button>
                                <div onClick={togglePreview}>Preview <i className="fa fa-eye"></i></div>
                                <img src={'data:image/png;base64,' + image} style={{ cursor: "pointer" }} height="100px" width="100px" alt="" onClick={togglePreview} /> */}
                            <button className="previewUploadedImage" onClick={togglePreview}>Preview <i className="fa fa-eye"></i></button>
                            <button className="removeUploadedImage" onClick={removeImg}>Remove</button>
                        </div>
                    }
                    <div className=" d-flex w-100 justify-content-center mt-1" id="UTRNumber">
                        <input type="text" minLength="12" className="w-100 floating" placeholder="Enter TID" value={orderDetails?.utr} onChange={(e) => { ((/^[1-9][0-9]*$/.test(e.target.value) || e.target.value === '') && setOrderDetails({ ...orderDetails, utr: e.target.value })) }} id="utr" name="utr" required />
                    </div>
                </div>
            </div>


            <div className="qr-code-container1 fcol mt-2">
                <div className="paymentAccordianWrapper" style={{
                    ['--tab-count']: redirectLinks?.qr.length,
                    ['--active-index']: redirectLinks?.qr.findIndex(ele => ele === orderDetails),
                }}
                    role="radiogroup">
                    {redirectLinks?.qr.map(t =>
                        <button key={t.payMethod} type="button" aria-checked={orderDetails?.payMethod === t.payMethod}
                            role="radio" className={`paymentAccordion${orderDetails?.payMethod === t.payMethod ? " activePakPayMethod" : ""}`} onClick={() => { setSelectedMethod(t); setOrderDetails((prev) => ({ ...prev, payMethod: t.payMethod })) }}>{t.payMethod}</button>
                    )}
                </div>
                <div>
                    <h4 style={{ fontWeight: "700", color: "#777" }}>QR code</h4>
                    <p style={{ fontSize: "14px" }}>Use it once-reusing it will result in loss of funds</p>
                </div>
                <img height={200} src={'data:image/png;base64,' + selectedMethod?.qrCode} alt={orderDetails?.payMethod} />
                {Boolean(selectedMethod?.upiId) && <p style={{ fontSize: "20px", fontWeight: "700", color: "#777", marginBottom: "0px", marginTop: "10px", textAlign: "center", position: 'relative' }}>TILL ID: {982302821}  <CopyToClipboard text={982302821}>
                    <i className="fa-regular fa-copy " style={{ fontSize: "25px", color: "#888", cursor: "pointer" }}></i>
                </CopyToClipboard>
                    {showCopiedInfo && <div className="copiedToClipBoard">Copied</div>}
                </p>}
                <p className="description mt-1">Pay with Payment app or scan one time QR code.</p>
                <div className="form-group mt-1">
                    <label>Order ID:{orderDetails?.orderId ? orderDetails?.orderId : "N/A"}</label>
                </div>
                <div className="form-group amount_grp p-0">
                    <label>AMOUNT: <span className="amount" style={{ fontSize: '20px' }}>{redirectLinks?.currencySymbol ? redirectLinks?.currencySymbol : redirectLinks?.currency} {orderDetails?.amount ? Number(orderDetails?.amount).toFixed(2) : "N/A"}</span></label>
                </div>
                {Boolean(selectedMethod?.bankName) && <div div className="form-group amount_grp p-0">
                    <label>Name: <span className="amount" style={{ fontSize: '20px' }}>{selectedMethod?.bankName}</span></label>
                </div>}
            </div>
            <div className="deposit_page"> <div className="text-center header_tag mb-4">
                <button title="Cancel" className="back_button fa-solid fa-xmark" onClick={cancelButton}></button>
                <div className="d-flex align-items-center"><img src={valueLinkLogo} height="50px" alt="" /></div>
                {<p id="timer"><span id="countdown">00:00</span></p>}
            </div>
                <div className="form-container">

                    {/* <div className="form-group" style={{ position: "relative" }}>
                    <label>UPI ID:</label>
                    <input type="text" placeholder="UPI ID" id="upiId" value={orderDetails?.upiId ? orderDetails?.upiId : "N/A"} disabled />
                    <div style={{ position: "absolute", bottom: "10%", right: "4%" }}>
                        <CopyToClipboard text={orderDetails?.upiId}>
                            <i className="fa-regular fa-copy " style={{ fontSize: "25px", color: "#888", cursor: "pointer" }}></i>
                        </CopyToClipboard>
                    </div>
                </div> */}

                    {/* <div className="form-group">
                    <label>Merchant ID:</label>
                    <input type="text" id="merchantId" placeholder="Merchant ID" value={orderDetails?.merchantId ? orderDetails?.merchantId : "N/A"} disabled />
                </div> */}
                    {/* <div className="errormessage">
                    <p id='dataMessage'></p>
                </div> */}
                    {/* <button onClick={()=>{window.location.href="gpay://pay?pa=rminizlp322107@ypbiz&pn=PhonePeMerchant&mc=0000&mode=02&purpose=00&tr=860f9851-cdfc-4a67-9d80-3a90b69ecdad&tn=26739c12-5028-40b5-9f35-c21ee439fa44&am=13.0"}}>Test</button> */}

                    {/* <button id="Cancel" onClick={cancelButton} type="submit">Cancel</button> */}
                </div>
            </div>
        </>
        }

        {
            !isPortrait && <>
                <div className="deposit_page pt-0 pb-0">
                    <div className="text-center header_tag w-75 ms-auto me-auto">
                        <button title="Cancel" className="back_button1 fa-solid fa-xmark" onClick={cancelButton}></button>
                        <div className="d-flex align-items-center"><img src={valueLinkLogo} height="50px" alt="" /></div>
                        {<p id="timer"><span id="countdown">00:00</span></p>}
                    </div>
                    {redirectLinks?.message && <p id="bonus1" className="text-center">{redirectLinks?.message}</p>}
                    <div className="order_box justify-content-center">
                        <div className="qrBox w-75">
                            <h1 id="TimeStamp_check"></h1>
                            <div className="qr-code-container1 fcol" style={{ backgroundColor: "#FFF" }}>
                                <div className="paymentAccordianWrapper" style={{
                                    ['--tab-count']: redirectLinks?.qr.length,
                                    ['--active-index']: redirectLinks?.qr.findIndex(ele => ele.payMethod === orderDetails?.payMethod),
                                }}
                                    role="radiogroup">
                                    {redirectLinks?.qr.map(t =>
                                        <button key={t.payMethod} type="button" aria-checked={orderDetails?.payMethod === t.payMethod}
                                            role="radio" className={`paymentAccordion${orderDetails?.payMethod === t.payMethod ? " activePakPayMethod" : ""}`} onClick={() => { setSelectedMethod(t); setOrderDetails((prev) => ({ ...prev, payMethod: t.payMethod })) }}>{t.payMethod}</button>
                                    )}
                                </div>
                                <div>
                                    <h4 style={{ fontWeight: "700", color: "#777" }}>QR code</h4>
                                    <p style={{ fontSize: "14px", marginBottom: "0" }}>Use it once-reusing it will result in loss of funds</p>
                                </div>
                                {Boolean(selectedMethod?.bankName) && <div div className="form-group amount_grp p-0">
                                    <label><span className="amount" style={{ fontSize: '24px', display: "block", textAlign: "center", color: '#1DAB87', fontWeight: "800" }}>{selectedMethod?.bankName}</span></label>
                                </div>}
                                <div ref={qrRef} className="qrCover1 ms-auto me-auto">
                                    <img height={250} style={{ maxWidth: "100%" }} src={'data:image/png;base64,' + selectedMethod?.qrCode} />
                                    {Boolean(selectedMethod?.upiId) && <p style={{ fontSize: "20px", fontWeight: "700", color: "#777", marginBottom: "0px", marginTop: "10px", textAlign: "center", position: "relative" }}>TILL ID: {982302821}  <CopyToClipboard text={982302821} onCopy={handleCopiedMessage}>
                                        <i className="fa-regular fa-copy " style={{ fontSize: "25px", color: "#888", cursor: "pointer" }}></i>
                                    </CopyToClipboard>
                                        {showCopiedInfo && <div className="copiedToClipBoard">Copied</div>}
                                    </p>}
                                </div>
                                <p className="description text-center">Pay with app or scan one time QR code.</p>
                                <div className="form-group">
                                    <label>Order ID:<span className="text-dark" style={{ fontSize: "14px" }}>{orderDetails?.orderId ? orderDetails?.orderId : "N/A"}</span></label>
                                </div>
                                <div className="form-group">
                                    <label>Amount: <span style={{ color: '#1DAB87' }} id="amount">{orderDetails?.amount ? `${redirectLinks?.currency ? redirectLinks?.currency : "N/A"} ${Number(orderDetails?.amount).toFixed(2)}` : "N/A"}</span></label>
                                </div>


                                <div className="text-center mt-2">
                                    <div className="">
                                        <h6>{Boolean(fileValue) ? "Please check uploaded image before confirming payment." : "Please upload receipt after payment."}</h6>
                                        <h6 style={{ fontSize: "14px", fontWeight: "700" }} className="text-center ms-auto me-auto text-danger">{errMsg}</h6>
                                        {!fileValue && <div className=" d-flex justify-content-left mt-2" style={{ width: "90%" }} id="paymentProofDiv">
                                            <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => { getBase64(e); setFileValue(e.target.value?.split("\\").pop()) }} name="paymentProof" id="paymentProof" />
                                            <div id="fileName" onClick={() => document.getElementById("paymentProof").click()}>
                                                <button className="green_btn chooseFile_btn">Choose File</button>
                                                <span style={{ color: "#777" }}>{fileValue ? fileValue : 'Upload Payment Proof'}</span>
                                            </div>
                                        </div>}
                                        {
                                            fileValue && <div className="image_preview text-center df">
                                                {/* <button title="Remove" className="remove_img fa-solid fa-xmark" onClick={removeImg}></button>
                                                <div onClick={togglePreview}>Preview <i className="fa fa-eye"></i></div>
                                                <img src={'data:image/png;base64,' + image} style={{ cursor: "pointer" }} height="100px" width="100px" alt="" onClick={togglePreview} /> */}
                                                <button className="previewUploadedImage" onClick={togglePreview}>Preview <i className="fa fa-eye"></i></button>
                                                <button className="removeUploadedImage" onClick={removeImg}>Remove</button>
                                            </div>
                                        }
                                        <div className=" d-flex w-100 justify-content-center" id="UTRNumber">
                                            <input type="text" minLength="12" className="w-50 floating" placeholder="Enter TID" value={orderDetails?.utr} onChange={(e) => { ((/^[1-9][0-9]*$/.test(e.target.value) || e.target.value === '') && setOrderDetails({ ...orderDetails, utr: e.target.value })) }} id="utr" name="utr" required />
                                        </div>
                                        <div className="text-center">
                                            <button id="PayNow1" className="popup-button w-50 p-0 ms-auto me-auto" disabled={!paymentImg || !orderDetails?.utr} onClick={() => { pendingConfirmation() }}>Confirm Payment</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        }
    </div >
}

export default PakistanPaymentPage